import { createRouter, createWebHistory, RouterView } from "vue-router";
import store from '@/store'

const DefaultContainer          = () => import('@/containers/DefaultContainer')
const Page404                   = () => import('@/views/errors/Page404')
// const Page500                   = () => import('@/views/errors/Page500')
const Login                     = () => import('@/views/Auth/Login')
// const ChangePassword            = () => import('@/views/auth/ResetPassword')
const ForgotPassword            = () => import('@/views/Auth/ForgotPassword')
const ResetPassword             = () => import('@/views/Auth/ResetPassword')



// Views

//Workout
const WorkoutOverview           = () => import('@/views/Workouts/Workout/Overview')
const WorkoutCrud               = () => import('@/views/Workouts/Workout/Workout')

const ConditioningOverview      = () => import('@/views/Workouts/Conditioning/Overview')
const ConditioningCrud          = () => import('@/views/Workouts/Conditioning/Conditioning')

const ConditioningTypeOverview  = () => import('@/views/Workouts/Conditioning/ConditioningType')
const ConditioningTypeCrud      = () => import('@/views/Workouts/Conditioning/AddConditioningType')

const MovementOverview          = () => import('@/views/Workouts/Movement/Overview')
const MovementCrud              = () => import('@/views/Workouts/Movement/Movement')

const MovementTypeOverview      = () => import('@/views/Workouts/Movement/TypeOverview')
const MovementTypeCrud          = () => import('@/views/Workouts/Movement/Type')

const StrenghtOverview          = () => import('@/views/Workouts/Strength/StrengthOverview')
const StrenghtCrud              = () => import('@/views/Workouts/Strength/Strength')

const PeopleMembers             = () => import('@/views/People/Members.vue')
const PeopleMembership          = () => import('@/views/People/Membership')
const PeopleRegister            = () => import('@/views/People/Register')

const SubscriptionOverview      = () => import('@/views/Subscription/Overview')
const SubscriptionCrud          = () => import('@/views/Subscription/Subscription')

const ProgramOverview           = () => import('@/views/Workouts/Program/Overview')
const ProgramCrud               = () => import('@/views/Workouts/Program/Program')

const WarmupOverview           = () => import('@/views/Workouts/Warmup/Overview')
const WarmupCrud               = () => import('@/views/Workouts/Warmup/Warmup')

const CooldownOverview           = () => import('@/views/Workouts/Cooldown/Overview')
const CooldownCrud               = () => import('@/views/Workouts/Cooldown/Cooldown')

const AccessoryOverview           = () => import('@/views/Workouts/Accessory/Overview')
const AccessoryCrud               = () => import('@/views/Workouts/Accessory/Accessory')

const EquipmentOverview         = () => import('@/views/Workouts/Equipment/Overview')
const EquipmentCrud             = () => import('@/views/Workouts/Equipment/Equipment')

const DivisionOverview          = () => import('@/views/Workouts/Division/Overview')
const DivisionCrud              = () => import('@/views/Workouts/Division/Division')

const Calendar                  = () => import('@/views/Calendar')
const Dashboard                 = () => import('@/views/Dashboard')

const requireAuthenticated = (to, from, next) => {
  store.dispatch('auth/current')
    .then(() => {
      if (!store.getters['auth/isAuthenticated']) {
        next({ path: '/login', replace: true, query: { redirect: to.fullPath } })
      } else {
        next()
      }
    })
}

const requireUnauthenticated = (to, from, next) => {
  store.dispatch('auth/current')
    .then(() => {
      if (store.getters['auth/isAuthenticated']) {
        next('/dashboard', { replace: true })
      } else {
        next()
      }
    })
}

const redirectLogout = (to, from, next) => {
  store.dispatch('auth/logout')
    .then(() => next('/login'))
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
      {
        path: '/',
        redirect: '/dashboard',
        component: DefaultContainer,
        children: [
          {
            path: 'dashboard',
            name: 'Dashboard',
            component: Dashboard,
            beforeEnter: requireAuthenticated,
            meta: {
              tag: 'dashboard',
              breadcrumb: [
                { label: 'Dashboard', link: '/dashboard' },
              ]
            }
          },
          {
            path: '/members',
            redirect: '/members/overview',
            component: RouterView,
            children: [
              {
                path: 'overview',
                component: PeopleMembers,
                beforeEnter: requireAuthenticated,
                meta: {
                  tag: 'members',
                  breadcrumb: [
                    { label: 'Members', link: '/members' },
                  ]
                }
              },
              {
                path: 'register',
                component: PeopleRegister,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Members', link: '/members' },
                    { label: 'Register', link: '/members/register' },
                  ]
                }
              },
              {
                path: 'register/:id',
                component: () => import("@/views/People/Register.vue"),
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Members', link: '/members' },
                    { label: 'Register', link: '/members/register' },
                  ]
                }
              },
              {
                path: 'memberships',
                component: PeopleMembership,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Members', link: '/members' },
                    { label: 'Memberships', link: '/members/memberships' },
                  ]
                }
              },
            ]
          },
          {
            path: '/subscriptions',
            redirect: '/subscriptions/overview',
            component: RouterView,
            children: [
              {
                path: 'overview',
                component: SubscriptionOverview,
                beforeEnter: requireAuthenticated,
                meta: {
                  tag: 'subscriptions',
                  breadcrumb: [
                    { label: 'Subscriptions', link: '/subscriptions' },
                  ]
                }
              },
              {
                path: 'add',
                component: SubscriptionCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Subscriptions', link: '/subscriptions' },
                    { label: 'Add Subscription', link: '/subscriptions/add' },
                  ]
                }
              },
              {
                path: 'subscriptions/:id',
                component: () => import("@/views/Subscription/Subscription.vue"),
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Subscriptions', link: '/subscriptions' },
                    { label: 'Subscription Details', link: '/subscriptions/:id' },
                  ]
                }
              },
            ]
          },
          {
            path: '/equipments',
            redirect: '/equipments/overview',
            component: RouterView,
            children: [
              {
                path: 'overview',
                component: EquipmentOverview,
                beforeEnter: requireAuthenticated,
                meta: {
                  tag: 'equipments',
                  breadcrumb: [
                    { label: 'Equipments', link: '/equipments' },
                  ]
                }
              },
              {
                path: 'add',
                component: EquipmentCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Equipments', link: '/equipments' },
                    { label: 'Add Equipment', link: '/equipments/add' },
                  ]
                }
              },
              {
                path: 'edit/:id',
                component: EquipmentCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Equipments', link: '/equipments' },
                    { label: 'Edit Equipment', link: '/equipments/edit/:id' },
                  ]
                }
              },
            ]
          },
          {
            path: '/divisions',
            redirect: '/divisions/overview',
            component: RouterView,
            children: [
              {
                path: 'overview',
                component: DivisionOverview,
                beforeEnter: requireAuthenticated,
                meta: {
                  tag: 'divisions',
                  breadcrumb: [
                    { label: 'Divisions', link: '/divisions' },
                  ]
                }
              },
              {
                path: 'add',
                component: DivisionCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Divisions', link: '/divisions' },
                    { label: 'Add Division', link: '/divisions/add' },
                  ]
                }
              },
              {
                path: 'edit/:id',
                component: DivisionCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Divisions', link: '/divisions' },
                    { label: 'Edit Division', link: '/divisions/edit/:id' },
                  ]
                }
              },
            ]
          },
          {
            path: '/movements',
            redirect: '/movements/overview',
            component: RouterView,
            children: [
              {
                path: 'overview',
                component: MovementOverview,
                beforeEnter: requireAuthenticated,
                meta: {
                  tag: 'movements',
                  breadcrumb: [
                    { label: 'Movements', link: '/movements' },
                  ]
                }
              },
              {
                path: 'add',
                component: MovementCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Movements', link: '/movements' },
                    { label: 'Add Movement', link: '/movements/add' },
                  ]
                }
              },
              {
                path: 'edit/:id',
                component: MovementCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Movements', link: '/movements' },
                    { label: 'Edit Movement', link: '/movements/edit/:id' },
                  ]
                }
              },
            ]
          },
          {
            path: '/movement-types',
            redirect: '/movement-types/overview',
            component: RouterView,
            children: [
              {
                path: 'overview',
                component: MovementTypeOverview,
                beforeEnter: requireAuthenticated,
                meta: {
                  tag: 'movement-type',
                  breadcrumb: [
                    { label: 'Movement Types', link: '/movement-types' },
                  ]
                }
              },
              {
                path: 'add',
                component: MovementTypeCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Movement Types', link: '/movement-types' },
                    { label: 'Add Movement Type', link: '/movement-types/add' },
                  ]
                }
              },
              {
                path: 'edit/:id',
                component: MovementTypeCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Movement Types', link: '/movement-types' },
                    { label: 'Edit Movement Type', link: '/movement-types/edit/:id' },
                  ]
                }
              },
            ]
          },
          {
            path: '/metcons',
            redirect: '/metcons/overview',
            component: RouterView,
            children: [
              {
                path: 'overview',
                component: ConditioningOverview,
                beforeEnter: requireAuthenticated,
                meta: {
                  tag: 'conditioning',
                  breadcrumb: [
                    { label: 'Metcons', link: '/metcons' },
                  ]
                }
              },
              {
                path: 'add',
                component: ConditioningCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Metcons', link: '/metcons' },
                    { label: 'Add Metcon', link: '/metcons/add' },
                  ]
                }
              },
              {
                path: 'edit/:id',
                component: ConditioningCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Metcons', link: '/metcons' },
                    { label: 'Edit Metcon', link: '/metcons/edit/:id' },
                  ]
                }
              },
            ]
          },
          {
            path: '/workouts',
            redirect: '/workouts/overview',
            component: RouterView,
            children: [
              {
                path: 'overview',
                component: WorkoutOverview,
                beforeEnter: requireAuthenticated,
                meta: {
                  tag: 'workouts',
                  breadcrumb: [
                    { label: 'Workouts', link: '/workouts' },
                  ]
                }
              },
              {
                path: 'edit/:id',
                component: WorkoutCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Workouts', link: '/workouts' },
                    { label: 'Edit Workout', link: '/workouts/edit/:id' },
                  ]
                }
              },
              {
                path: 'add',
                component: WorkoutCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Workouts', link: '/workouts' },
                    { label: 'Add Workout', link: '/workouts/add' },
                  ]
                }
              },
            ]
          },
          {
            path: '/programs',
            redirect: '/programs/overview',
            component: RouterView,
            children: [
              {
                path: 'overview',
                component: ProgramOverview,
                beforeEnter: requireAuthenticated,
                meta: {
                  tag: 'programs',
                  breadcrumb: [
                    { label: 'Programs', link: '/programs' },
                  ]
                }
              },
              {
                path: 'add',
                component: ProgramCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Programs', link: '/programs' },
                    { label: 'Add Program', link: '/programs/add' },
                  ]
                }
              },
              {
                path: 'edit/:id',
                component: ProgramCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Programs', link: '/programs' },
                    { label: 'Edit Program', link: '/programs/edit/:id' },
                  ]
                }
              },
            ]
          },
          {
            path: '/strength',
            redirect: '/strength/overview',
            component: RouterView,
            children: [
              {
                path: 'overview',
                component: StrenghtOverview,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Strength', link: '/strength' },
                  ]
                }
              },
              {
                path: 'add',
                component: StrenghtCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Strength', link: '/strength' },
                    { label: 'Add Strength', link: '/strength/add' },
                  ]
                }
              },
              {
                path: 'edit/:id',
                component: StrenghtCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Strength', link: '/strength' },
                    { label: 'Edit Strength', link: '/strength/edit/:id' },
                  ]
                }
              },
            ]
          },
          {
            path: '/warm-up',
            redirect: '/warm-up/overview',
            component: RouterView,
            children: [
              {
                path: 'overview',
                component: WarmupOverview,
                beforeEnter: requireAuthenticated,
                meta: {
                  tag: 'warm-up',
                  breadcrumb: [
                    { label: 'Warm-up', link: '/warm-up' },
                  ]
                }
              },
              {
                path: 'add',
                component: WarmupCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Warm-up', link: '/warm-up' },
                    { label: 'Add Warm-up', link: '/warm-up/add' },
                  ]
                }
              },
              {
                path: 'edit/:id',
                component: WarmupCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Warm-up', link: '/warm-up' },
                    { label: 'Edit Warm-up', link: '/warm-up/edit/:id' },
                  ]
                }
              },
            ]
          },
          {
            path: '/cooldowns',
            redirect: '/cooldowns/overview',
            component: RouterView,
            children: [
              {
                path: 'overview',
                component: CooldownOverview,
                beforeEnter: requireAuthenticated,
                meta: {
                  tag: 'cooldowns',
                  breadcrumb: [
                    { label: 'Cooldowns', link: '/cooldowns' },
                  ]
                }
              },
              {
                path: 'add',
                component: CooldownCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Cooldowns', link: '/cooldowns' },
                    { label: 'Add Cooldown', link: '/cooldowns/add' },
                  ]
                }
              },
              {
                path: 'edit/:id',
                component: CooldownCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Cooldowns', link: '/cooldowns' },
                    { label: 'Edit Cooldown', link: '/cooldowns/edit/:id' },
                  ]
                }
              },
            ]
          },
          {
            path: '/accessorys',
            redirect: '/accessorys/overview',
            component: RouterView,
            children: [
              {
                path: 'overview',
                component: AccessoryOverview,
                beforeEnter: requireAuthenticated,
                meta: {
                  tag: 'accessorys',
                  breadcrumb: [
                    { label: 'Accessories', link: '/accessorys' },
                  ]
                }
              },
              {
                path: 'add',
                component: AccessoryCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Accessories', link: '/accessorys' },
                    { label: 'Add Accessory', link: '/accessorys/add' },
                  ]
                }
              },
              {
                path: 'edit/:id',
                component: AccessoryCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Accessories', link: '/accessorys' },
                    { label: 'Edit Accessory', link: '/accessorys/edit/:id' },
                  ]
                }
              },
            ]
          },
          {
            path: '/conditioning-type',
            redirect: '/conditioning-type/overview',
            component: RouterView,
            children: [
              {
                path: 'overview',
                component: ConditioningTypeOverview,
                beforeEnter: requireAuthenticated,
                meta: {
                  tag: 'conditioning-type',
                  breadcrumb: [
                    { label: 'Conditioning Types', link: '/conditioning-type' },
                  ]
                }
              },
              {
                path: 'add',
                component: ConditioningTypeCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Conditioning Types', link: '/conditioning-type' },
                    { label: 'Add Conditioning Type', link: '/conditioning-type/add' },
                  ]
                }
              },
              {
                path: 'edit/:id',
                component: ConditioningTypeCrud,
                beforeEnter: requireAuthenticated,
                meta: {
                  breadcrumb: [
                    { label: 'Conditioning Types', link: '/conditioning-type' },
                    { label: 'Edit Conditioning Type', link: '/conditioning-type/edit/:id' },
                  ]
                }
              },
            ]
          },
          {
            path: '/calendar',
            component: Calendar,
            beforeEnter: requireAuthenticated,
            meta: {
              breadcrumb: [
                { label: 'Calendar', link: '/calendar' },
              ]
            }
          }
        ]
      },
      {
        path: '/login',
        component: Login,
        beforeEnter: requireUnauthenticated,
        meta: {
          hideMenu: true,
          hideHeader:true,
        }
      },
      // {
      //   path: '/change_password',
      //   component: ChangePassword,
      //   beforeEnter: requireAuthenticated,
      // },
      {
        path: '/logout-user',
        component: {
          beforeEnter: redirectLogout
        },
        beforeEnter: redirectLogout,
      },
      {
        path: '/forgotpassword',
        component: ForgotPassword,
        beforeEnter: requireUnauthenticated,
        meta: {
          hideMenu: true,
          hideHeader:true
        }
      },
      {
        path: '/reset-password/:uid/:token',
        component: ResetPassword,
        beforeEnter: requireUnauthenticated,
        meta: {
          hideMenu: true,
          hideHeader:true
        }
      },
      {
        path: "/:catchAll(.*)",
        component: Page404
      },
  ]
});

export default router;
